module.exports = [{
      plugin: require('/home/devinhenkel/Projects/lightsail/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/bulb-icon.png"},
    },{
      plugin: require('/home/devinhenkel/Projects/lightsail/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
